import React from "react"

export default () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <circle cx="3.5" cy="12.5" r="2.5" />
    <circle cx="11.5" cy="12.5" r="2.5" />
    <circle cx="19.5" cy="12.5" r="2.5" />
  </svg>
)
